const UpdateCategoriesReducer = (state, action) => ({
  ...state,
  files: action.payload.files
});

export default UpdateCategoriesReducer;
